import {
  ActiveDevice,
  LocalParticipant,
  Stream,
  ParticipantData
} from "@domain";
import {
  IBlocSyncInteractor,
  SyncInteractor
} from "@kernel/frontend-react-app";
import { UserType } from "../UserType";

export interface CreateLocalParticipantInteractorProps {
  displayName: string;
  type: UserType;
  activeDevice: ActiveDevice;
  stream: Stream;
}

export class CreateLocalParticipantInteractor
  extends SyncInteractor<
    CreateLocalParticipantInteractorProps,
    LocalParticipant
  >
  implements
    IBlocSyncInteractor<CreateLocalParticipantInteractorProps, LocalParticipant>
{
  public execute({
    displayName,
    type,
    activeDevice,
    stream
  }: CreateLocalParticipantInteractorProps): LocalParticipant {
    const paticipantData = ParticipantData.create({
      displayName,
      type
    });
    const participant = LocalParticipant.create({
      data: paticipantData,
      activeDevice,
      stream,
      pinned: true
    });
    return participant;
  }

  public static create(): CreateLocalParticipantInteractor {
    return new CreateLocalParticipantInteractor();
  }
}
